import { forwardRef, useRef } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { Typography } from '../Typography/Typography.js';
import { getContentTagStyles, getTypographyStyles, getRemoveIconStyles } from './ContentTagStyles.js';
import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';
import { ContentTagVariant } from './types/variant.js';
import { useHoverableTooltip } from '../Tooltip/useTooltip.js';
import { Icon } from '../Icon/Icon.js';
import { IconSize } from '../Icon/types/size.js';
import { Tooltip } from '../Tooltip/Tooltip.js';

/**
 * @deprecated Please use the new Next.ContentTag instead
 */
const ContentTag = /*#__PURE__*/forwardRef((_ref, reference) => {
  let {
    value,
    children,
    removeLabel,
    showRemoveLabelTooltip = false,
    variant = ContentTagVariant.REGULAR,
    onClickRemove,
    ...rest
  } = _ref;
  const removeIconRef = useRef(null);
  const {
    opened
  } = useHoverableTooltip(removeIconRef);
  return jsxs("div", {
    ref: reference,
    css: getContentTagStyles,
    ...rest,
    children: [jsx(Typography, {
      bold: true,
      component: "span",
      css: getTypographyStyles,
      variant: variant === ContentTagVariant.REGULAR ? 'body2' : 'body1',
      children: children
    }), onClickRemove && value && jsxs(Fragment, {
      children: [jsx(Icon, {
        role: "button",
        ref: removeIconRef,
        name: IconNames.CLOSE,
        "aria-label": removeLabel,
        css: getRemoveIconStyles(variant),
        onClick: e => onClickRemove(e, value),
        size: variant === ContentTagVariant.REGULAR ? IconSize.SIZE_MEDIUM : IconSize.SIZE_REGULAR
      }), showRemoveLabelTooltip && jsx(Tooltip, {
        isOpen: opened,
        id: `tooltip-remove-${value}`,
        reference: removeIconRef.current,
        children: removeLabel
      })]
    })]
  });
});
ContentTag.displayName = 'ContentTag';

export { ContentTag };
//# sourceMappingURL=ContentTag.js.map
